export function formatMonth(month: number): string {
  if (typeof month !== 'number' || Number.isNaN(+month))
    return month.toString();
  const m = month.toString();
  return m.length === 1 ? `0${m}` : m;
}
